import { useEffect } from "react";

/**
 * Simple SEO helper — sets document.title plus a few meta tags directly.
 * Avoids react-helmet-async dependency. Cleans up on unmount.
 */
export default function SEO({ title, description, image, url, type = "product" }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs.id || {}).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      Object.entries(attrs.set || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null) el.setAttribute(k, v);
      });
      return el;
    };

    const tagsAdded = [];
    const upsert = (selector, idAttrs, setAttrs) => {
      let el = document.head.querySelector(selector);
      const created = !el;
      if (!el) {
        el = document.createElement("meta");
        Object.entries(idAttrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      Object.entries(setAttrs).forEach(([k, v]) => {
        if (v !== undefined && v !== null) el.setAttribute(k, v);
      });
      if (created) tagsAdded.push(el);
      return el;
    };

    if (description) {
      upsert('meta[name="description"]', { name: "description" }, { content: description });
      upsert('meta[property="og:description"]', { property: "og:description" }, { content: description });
      upsert('meta[name="twitter:description"]', { name: "twitter:description" }, { content: description });
    }
    if (title) {
      upsert('meta[property="og:title"]', { property: "og:title" }, { content: title });
      upsert('meta[name="twitter:title"]', { name: "twitter:title" }, { content: title });
    }
    if (image) {
      upsert('meta[property="og:image"]', { property: "og:image" }, { content: image });
      upsert('meta[name="twitter:image"]', { name: "twitter:image" }, { content: image });
      upsert('meta[name="twitter:card"]', { name: "twitter:card" }, { content: "summary_large_image" });
    }
    if (url) {
      upsert('meta[property="og:url"]', { property: "og:url" }, { content: url });
    }
    upsert('meta[property="og:type"]', { property: "og:type" }, { content: type });

    return () => {
      document.title = prevTitle;
      // Don't aggressively remove tags so other pages can override them; let the next mount overwrite
    };
  }, [title, description, image, url, type]);

  return null;
}
